import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { IonModal } from '@ionic/angular/standalone';

import { modalSheetEnter, modalSheetLeave } from './modal-sheet.animation';
import { SheetDragDirection, SheetHandleComponent } from './sheet-handle.component';

/**
 * Hoja modal: un `ion-modal` con la apariencia del diseño. Ionic pone lo difícil, que no conviene reescribir:
 * se monta en `ion-app`, por encima de toda página y de la barra inferior, atrapa el foco, y el velo, Escape y
 * el botón atrás de Android la cierran, en orden si hay varias. Aquí sólo van el asa, el tema y la animación.
 */
@Component({
  selector: 'ui-modal-sheet',
  imports: [IonModal, SheetHandleComponent],
  template: `
    <ion-modal
      class="ui-modal-sheet"
      [isOpen]="open()"
      [enterAnimation]="enter"
      [leaveAnimation]="leave"
      [attr.aria-label]="label()"
      (didDismiss)="open.set(false)"
    >
      <ng-template>
        <ui-sheet-handle [expanded]="true" label="Cerrar hoja" (tapped)="open.set(false)" (dragged)="onDrag($event)" />
        <div class="body"><ng-content /></div>
      </ng-template>
    </ion-modal>
  `,
  styleUrl: './modal-sheet.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalSheetComponent {
  readonly label = input.required<string>();
  readonly open = model(false);

  protected readonly enter = modalSheetEnter;
  protected readonly leave = modalSheetLeave;

  protected onDrag(direction: SheetDragDirection): void {
    if (direction === 'down') this.open.set(false);
  }
}
